/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo } from "react";
import "./ReferenceLayerItem.scss";
import { MapContext } from "../../../context/MapContext";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import Chip from "@material-ui/core/Chip";
import CheckIcon from "@material-ui/icons/Check";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import utils from "../../../helpers/utils";
import { RefLayers } from "../ReferenceLayersConfig";

function ReferenceLayerItem(props) {
  const [mapObject] = useContext(MapContext);
  const {
    isVisible,
    url,
    handleLayerToggle,
    info,
    isRadio,
    countries,
    // isMultiLayered,
    urls,
  } = props;

  const layerUrls = urls || [url];

  const refLayers = useMemo(() => {
    if (mapObject?.map) {
      return layerUrls.map((lUrl) => {
        const newLayer = info.isRaster
          ? new MapImageLayer({
              url: lUrl,
              title: info.overrideTitle || info.layer,
              sublayers: info.sublayers,
            })
          : new FeatureLayer({
              url: lUrl,
              title: info.overrideTitle || info.layer,
            });
        if (info.layer === "Areas of Conservation Importance") {
          newLayer.popupTemplate = {
            // autocasts as new PopupTemplate()
            title: "{Name}",
            content: [
              {
                type: "fields",
                fieldInfos: [
                  {
                    fieldName: "TotalOODs2",
                    label: "Birder Observer Days",
                  },
                  {
                    fieldName: "NumKeySpec",
                    label: "# key species",
                  },
                  {
                    fieldName: "NumEndemics",
                    label: "# of endemics",
                  },
                ],
              },
            ],
          };
        }

        if (info.layer === "Birdwatching Hotspots") {
          const spot = Object.values(RefLayers).findIndex((l) => l === lUrl);
          if (spot > -1) {
            if (
              Object.keys(RefLayers)[spot] === "Birdwatching Hotspots (Points)"
            ) {
              newLayer.popupTemplate = {
                title: "{PRIMARYNAM}{name}",
                content: "",
              };
              newLayer.definitionExpression = `COUNTRY in (${countries
                .map((c) => "'" + utils.getCountryForEEZ(c) + "'")
                .join(",")})`;
            }
            if (
              Object.keys(RefLayers)[spot] === "Birdwatching Hotspots (Areas)"
            ) {
              newLayer.popupTemplate = {
                title: "{description}",
                content: "{description}",
              };
            }
          }
        }

        return newLayer;
      });
    }
  }, [mapObject?.map, info, countries]);

  useEffect(() => {
    if (refLayers) {
      refLayers.forEach((refLayer) => {
        refLayer.visible = isVisible;
        if (isVisible) {
          mapObject?.map.reorder(refLayer, mapObject?.map.layers.length);
        }
      });
    }
  }, [refLayers, isVisible, mapObject?.map]);

  useEffect(() => {
    if (refLayers) {
      refLayers.forEach((refLayer) => {
        mapObject?.map.add(refLayer);
      });
    }

    return () => {
      if (refLayers) {
        refLayers.forEach((refLayer) => {
          mapObject?.map.remove(refLayer);
        });
      }
    };
  }, [mapObject?.map, refLayers]);

  return (
    <Chip
      icon={!isRadio && isVisible ? <CheckIcon /> : null}
      className={isVisible ? "referenceLayerItem active" : "referenceLayerItem"}
      label={
        <>
          <div className="layer-title">{info.title || info.layer}</div>
          <Tooltip
            arrow
            className="app-tooltip"
            interactive={!!info.link}
            title={
              <React.Fragment>
                {info.tooltip}{" "}
                {info.link ? (
                  <a rel="noreferrer" target="_blank" href={info.link}>
                    link
                  </a>
                ) : null}
              </React.Fragment>
            }
          >
            <InfoIcon className="info-icon" />
          </Tooltip>
        </>
      }
      onClick={() => handleLayerToggle(info.layer)}
    />
  );
}

export default ReferenceLayerItem;
